import { render, staticRenderFns } from "./sectionComponent.vue?vue&type=template&id=4b1c43ec&scoped=true"
import script from "./sectionComponent.vue?vue&type=script&lang=js"
export * from "./sectionComponent.vue?vue&type=script&lang=js"
import style0 from "./sectionComponent.vue?vue&type=style&index=0&id=4b1c43ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c43ec",
  null
  
)

export default component.exports